import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Form } from "semantic-ui-react";

import useAuth from "../../../login/AuthContext";
import {
  CreateRoom,
  RoomCreationRequest,
} from "../../../../services/NetworkApi";
import { ErrorResponse } from "../../../../services/Common";
import { RoomCreationPieces } from "./FormPieces";
import { useNetworkContext } from "../../../../contexts/NetworkContext/context";

interface CreateRoomModalProps {
  show: boolean;
  onClose: () => void;
  l1Id: number;
  l2Id: number;
  l3Id: number;
  l3Name: string;
}

export const CreateRoomModal: React.FunctionComponent<CreateRoomModalProps> = ({
  show,
  onClose,
  l1Id,
  l2Id,
  l3Id,
  l3Name,
}) => {
  const [error, setError] = useState({ error: false, msg: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { getAuthToken } = useAuth();
  const { loadNetworkInfoForNetworks } = useNetworkContext();
  const [info, setInfo] = useState<RoomCreationRequest>({
    roomName: undefined,
    numberInL3: undefined,
  });

  const [errors, setErrors] = useState({
    nameError: false,
    numberInL3Error: false,
  });

  const validateFields = () => {
    const validationErrors = { ...errors };

    const errored = false;

    // validationErrors.unitTypeNameError = info.unitTypeName == undefined;
    // errored = errored || info.unitTypeName == undefined;
    //
    // validationErrors.unitSizeError = info.unitSize == undefined || info.unitSize < 1;
    // errored = errored || info.unitSize == undefined || info.unitSize < 1;

    setErrors(validationErrors);
    return !errored;
  };

  const setValue = (value: string | boolean | number, field: string) => {
    setInfo({ ...info, [field]: value });
  };
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Create a room for {l3Name}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form
          error={error.error}
          onSubmit={async (event) => {
            event.preventDefault();

            if (isSubmitting) {
              return;
            }

            if (validateFields()) {
              setIsSubmitting(true);
              setError({ error: false, msg: "" });

              try {
                const createRoom = await CreateRoom(
                  l1Id,
                  l2Id,
                  l3Id,
                  info,
                  await getAuthToken()
                );

                if (!createRoom || createRoom instanceof ErrorResponse) {
                  setError({ msg: "something went wrong", error: true });
                  return;
                }

                await loadNetworkInfoForNetworks([l1Id]);
                onClose();
              } catch (error) {
                setError({ msg: "something went wrong", error: true });
              } finally {
                setIsSubmitting(false);
              }
            }
          }}
        >
          <RoomCreationPieces
            nameError={errors.nameError}
            numberInL3Error={errors.numberInL3Error}
            setValue={setValue}
          />

          <Button
            style={{ marginTop: "5px" }}
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Adding..." : "Add"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
